<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :options="{
      sortBy: ['dt'],
      sortDesc: [true]
    }"
    class="elevation-1"
  >
    <template v-slot:top>
      <strong
        class="print-only text-center"
        v-html="title"
      ></strong>
    </template>
    <template v-slot:item.dt="{ item }">
      <v-tooltip
        v-if="errorMessage( item )"
        bottom
        color="error"
      >
        <template v-slot:activator="{ on, attrs }">
          <span
            class="red--text"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon
              color="red"
            >
              {{ mdiAlertCircle }}
            </v-icon>
            <span class="pa-2">{{ item.dt }}</span>
          </span>
        </template>
        {{ errorMessage ( item ) }}
      </v-tooltip>
      <span v-else>
        {{ item.dt }}
      </span>
    </template>
    <template v-slot:item._buttons="{ item }">
      <v-row>
        <v-spacer></v-spacer>
        <v-btn
          class="ma-1"
          icon
          @click="editMeasure(item)"
        >
          <v-icon>{{ mdiPencil }}</v-icon>
        </v-btn>

        <v-btn
          class="ma-1"
          icon
          @click="deleteMeasure(item)"
        >
          <v-icon>{{ mdiTrashCan }}</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import {
  mdiPlus,
  mdiCalendar,
  mdiTrashCan,
  mdiPencil,
  mdiChevronDown,
  mdiAlertCircle
} from '@mdi/js'
import measureDB from '~/app/measure'
import config from '@/app/config'

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      mdiPlus,
      mdiCalendar,
      mdiTrashCan,
      mdiPencil,
      mdiChevronDown,
      mdiAlertCircle,
      headers: [
        {
          text: 'Дата',
          align: 'center',
          sortable: true,
          value: 'dt'
        },
        { text: 'Рост (см)', value: 'stature', align: 'center' },
        { text: 'Вес (кг)', value: 'weight', align: 'center' },
        { text: '', value: '_buttons' }
      ]
    }
  },
  computed: {
    activeProfile () {
      return this.$store.state.profile
    }
  },
  methods: {
    editMeasure (measure) {
      this.$emit('edit', measure)
    },
    deleteMeasure (measure) {
      if (confirm(
        'Вы действительно хотите удалить измерение за ' + measure.dt + '?'
      )) {
        measureDB.remove(measure.id).then(() => {
          for (let i in this.items) {
            if (this.items[i].id === measure.id) {
              this.items.splice(parseInt(i), 1)
              break
            }
          }
        })
      }
    },
    errorMessage (measure) {
      let messages = []
      let years = measureDB.getAgeInYears(this.activeProfile, measure)
      if (years < 2) {
        messages.push('Измерение не будет отражено на графиках (возраст ребёнка на дату измерения меньше 2 лет)')
      } else if (years > 20) {
        messages.push('Измерение не будет отражено на графиках (возраст ребёнка на дату измерения более 20 лет)')
      } else if (measure.weight && (measure.weight < config.graphs.weight.yMin || measure.weight > config.graphs.weight.yMax)) {
        messages.push('Заданный вес не будет отражён на графике, убедитесь, что вы ввели вес в килограммах')
      } else if (measure.stature && (measure.stature < config.graphs.stature.yMin || measure.stature > config.graphs.stature.yMax)) {
        messages.push('Заданный рост не будет отражён на графике, убедитесь, что вы ввели рост в сантиметрах')
      }
      return messages.length > 0 ? messages.join('\n') : ''
    }
  }
}
</script>
